import List from 'src/storage/list';

class PatientInvitationsModel extends List {
  id = 'PatientInvitationsModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    sortBy: {
      sortKey: 'addDate',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    removePatient: {
      url: 'invitation/remove',
      validation: {},
      cancellable: true
    },
    resend: {
      url: 'invitation/resend',
      validation: {},
      cancellable: true
    }
  };
  _events = {
    'ws:invite_patient': 'onInvitePatient',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onInvitePatient = (data) => {
    if (data.removedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);
      this.trigger();
    }
  };

  _matchMergeItem = (n, o) => ({ ...o, ...n });

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      status: this.state.status,
      sortBy: this.state.sortBy,
      role: 'patient'
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }
  remove = (item, cb) => {
    let req = {
      id: item.id
    };
    this.api('removePatient', req, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };
  resend = (id, cb) => {
    let req = {
      id
    };
    this.api('resend', req, (err, data, success) => {
      !!data?.invitation && this.onInvitePatient(data.invitation);
      cb && cb(err, data, success);
    });
  };
}

const model = new PatientInvitationsModel();
export default model;
